export const notificationsApiEndpoints = {
    NOTIFICATION_BELL: 'notification-bell',
};
